import { createAction } from 'typesafe-actions';

import type { ApplicationState } from '../types';

export const HYDRATE = '@@HYDRATE' as const;

/**
 * @deprecated
 */
export const nextHydrate = createAction(HYDRATE)<ApplicationState>();
